import { Pipe, PipeTransform } from '@angular/core';
import { MaintenanceProductService } from '@interfaces';

@Pipe({
  name: 'convertByValueType'
})
export class ConvertByValueTypePipe implements PipeTransform {
  public transform(orderProductService: MaintenanceProductService, companyId?: string): string {
    const productServiceCompany = orderProductService.item.productServiceCompanies.find(
      (psc) => psc.company.id === companyId
    );

    const valueType = productServiceCompany.valueType;

    if (!valueType) {
      return '-';
    }

    switch (valueType) {
      case 'hour':
        return this.convertToHours(orderProductService.quantity || 0);
      case 'kilometer':
        return `${((orderProductService.quantity || 0) / 1000).toFixed(2)}`;
      case 'fixed':
        return String(orderProductService.quantity || 0);
      default:
        return String(orderProductService.quantity || 0);
    }
  }

  private convertToHours(quantity: number): string {
    const hours = Math.floor(quantity / 60);
    const minutes = Math.floor(quantity % 60);
    const seconds = Math.round((quantity % 1) * 60);

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
}
